import { memo } from 'react';
import BuyIcon from '@tradera/blueprint/theme/icons2/buy.svg?jsx';
import { BuyMenu } from './buy-menu';
import { HOVER_MENUS } from './hover-menu/constants';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { myTraderaUrls } from 'tradera/apps/my-tradera/app/pages/routes';
import { Button } from 'tradera/components/atoms/button/button';
import { classNames } from 'tradera/utils/class-names';

type BuyingLinkProps = {
    onClick: (e: React.MouseEvent<HTMLElement>, menu: string) => void;
    mouseOver: (menu: string) => void;
    mouseOut: () => void;
    showMenu: boolean;
};

const BuyingLink = ({
    onClick,
    mouseOver,
    mouseOut,
    showMenu,
}: BuyingLinkProps) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const buyingText = t('siteHeader_buying');
    return (
        <div
            onMouseEnter={() => mouseOver(HOVER_MENUS.BUY)}
            onMouseLeave={mouseOut}>
            <Button
                theme="text"
                href={toLocalizedUrl(myTraderaUrls.bidding)}
                rel="nofollow"
                aria-label={buyingText}
                className={classNames('slim-header__button px-1', {
                    active: showMenu,
                })}
                title={buyingText}
                data-ga-category="Top navigation"
                data-ga-action="Buying menu"
                data-ga-label="Link - Ongoing auctions from NavBar"
                onClick={(e) => {
                    onClick(e, HOVER_MENUS.BUY);
                }}>
                <BuyIcon className="icon icon-md d-lg-none" />
                <span className={`slim-header__link-text d-none d-lg-inline`}>
                    {buyingText}
                </span>
            </Button>
            <BuyMenu showMenu={showMenu} />
        </div>
    );
};

export default memo(BuyingLink);
